// extracted by css-extract-rspack-plugin
export default {"content":"WYORg","body":"ypfxn"};